/**
 * Axios instance for Once V2 API calls
 * Includes JWT interceptor that automatically generates tokens for tenant hostnames
 */
import axios from 'axios';
import applyCsrfInterceptor from '@webapp-next/lib/request/utils/apply-csrf-interceptor';

const http = axios.create({
  baseURL: '/api',
});

applyCsrfInterceptor(http);

export const post = http.post;
export const put = http.put;
export const patch = http.patch;
export const remove = http.delete;
export const get = http.get;

export default http;
